var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('el-container',{staticClass:"container"},[_c('el-header',{staticClass:"head",staticStyle:{"height":"auto","max-height":"945px"}},[(
          ![
            'knowledge-base',
            'expert-base',
            'members-home',
            'search-result',
            'cfbb',
            'expertcenter'
          ].includes(_vm.$route.name)
        )?_c('Header'):_vm._e(),(
          [
            'knowledge-base',
            'expert-base',
            'members-home',
            'expertcenter'
          ].includes(_vm.$route.name)
        )?_c('BaseHeader'):_vm._e(),(!['cfbb'].includes(_vm.$route.name))?_c('div',{staticClass:"nav-wrap"},[_c('div',{staticClass:"nav-back"}),_c('nav-menu'),_c('div',{staticClass:"nav-back"})],1):_vm._e()],1),_c('el-main',[_c('keep-alive',{attrs:{"include":_vm.getKeepAliveList}},[_c('router-view')],1)],1),_c('el-footer',[_c('partner'),_c('friendly-link'),_c('Footer')],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.upShow),expression:"upShow"}],staticClass:"up-top"},[_c('div',{staticClass:"top",on:{"click":_vm.top}},[_c('i',{staticClass:"el-icon-arrow-up"})])]),_c('el-badge',{directives:[{name:"drag",rawName:"v-drag"}],attrs:{"id":"smart"},nativeOn:{"click":function($event){return _vm.smart($event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }